<template>
  <div :class="[$style.container, { [$style.containerActive]: isActive }]">
    <div :class="$style.avatar"></div>
    <div :class="$style.info">
      <div :class="$style.logo"></div>
      <div v-if="lastCallout" :class="$style.meta">
        {{ $t('blog.lastUpdate') }} {{ lastCallout | date('Pp') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'callouts-button',
  computed: {
    ...mapGetters({
      callouts: 'entities/callouts/list'
    }),
    isActive () {
      return this.$route.name === 'callouts' || this.$route.name === 'callouts-post'
    },
    lastCallout () {
      return this.callouts && this.callouts.length && this.callouts[0].created
    }
  }
}
</script>

<style module lang="scss">
.container {
  display: flex;
  height: 76px;
  padding: 10px 10px 10px 14px;
  margin-top: 8px;

  &:not(&Searched) {
    cursor: pointer;
  }
  &:hover:not(&Active):not(&Searched) {
    background-color: rgba($main-bg-darkest, 0.1);
  }
  &Active {
    background-color: $main-bg-darkest;
    color: $text-lightest;
    .logo {
      background-image: url('~@/assets/img/logo-callout-white.png');
    }
  }
}
.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background-color: $blue-dark;
  background-image: url('~@/assets/img/callout-q-white.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 36px;
}
.info {
  padding-top: 6px;
  padding-left: 10px;
  flex-basis: 0;
  flex-grow: 1;
  overflow: hidden;
}
.logo {
  background-image: url('~@/assets/img/logo-callout.png');
  background-position: left center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 32px;
}
.meta {
  font-size: 12px;
  color: $text-mid-dark;
}
</style>
